import React from 'react';

import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnNameAdmin = {
  path: 'name',
  sort: 'name',
  link: '/website/pages/:_id',
};

export const columnNameSeller = {
  path: 'name',
  sort: 'name',
  link: '/website/store/pages/:_id',
};

export const columnSlug = {
  title: 'Link',
  path: 'slug',
  render: (record) => `/${record.slug}`,
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const columnActive = {
  title: null,
  path: 'active',
  width: '20px',
  render: (record) => (
    record.active
    ? <CheckOutlined />
    : <CloseOutlined style={{ opacity: 0.2 }} />
  ),
};

export const ADMIN = [
  columnActive,
  columnNameAdmin,
  columnSlug,
  columnStore,
  columnCreatedAt,
  columnUpdatedAt,
];

export const SELLER = [
  columnActive,
  columnNameSeller,
  columnSlug,
  columnCreatedAt,
  columnUpdatedAt,
];
